import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  private _customizationConfig: {[name: string]: any} = {};


  get customizationConfig() {
    return this._customizationConfig;
  }

  constructor(
    private http: HttpClient,
  ) {}

  loadConfiguration() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.configUrl).subscribe(
        r => {
          if (Array.isArray(r) && r.length === 1 && r[0]) {
            const customization = r[0];
            [
              'color_scheme_name',
              'logo',
              'logoSmall',
              'favicon',
            ].forEach(
              f => {
                if (f in customization) {
                  this._customizationConfig[f] = customization[f];
                }
              }
            );
          }
          resolve(true);
        }
      );
    });
  }
}
